import { createApp } from 'vue'
import App from './App.vue'
import "./assets/color-scheme.css";
import "./assets/bootstrap-grid.css";

createApp(App).mount('#app')
